import { ComponentType, Dispatch, SetStateAction, useEffect, useState } from "react";
import cx from 'classnames';

import './ExternalFontSubForm.scss';
import { useQuery } from "@tanstack/react-query";
const FONT_SETTINGS_BORDER_ANIMATION_DURATION = 1000;
const IDLE_BODER_COLOR = 'light-dark(#bbb, #575757)'; // $idle-border-color

[
  {
    name: '--font-settings-border-colored-width',
    syntax: '<angle>',
    inherits: false,
    initialValue: '1turn',
  },
  {
    name: '--font-settings-border-color',
    syntax: '<color>',
    inherits: false,
    initialValue: IDLE_BODER_COLOR,
  },
  {
    name: '--font-settings-border-start',
    syntax: '<angle>',
    inherits: false,
    initialValue: '0turn',
  }
].forEach((p) => {
  try {
    CSS.registerProperty(p);
  } catch {
    // Was crashing when changing any value at platform embed page
    // CSS.registerProperty: Property already registered
  }
});

export type SubFormProps<SubformState> = { setSubFormNotEmpty: Dispatch<SetStateAction<boolean>>, state: SubformState };

export function ExternalFontSubForm<SubformState>(
  { visible: visibleProp, subform: Subform, subformState, queryOptions }:
  { visible: boolean, subform: ComponentType<SubFormProps<SubformState>>, subformState: SubformState, queryOptions: Parameters<typeof useQuery>[0] }
) {
  const [visible, setVisible] = useState(visibleProp);
  const [subFormNotEmpty, setSubFormNotEmpty] = useState(false);
  const [haveFocus, setHaveFocus] = useState(false);

  const { status } = useQuery({ enabled: false, ...queryOptions });

  useEffect(() => {
    setVisible(visibleProp || subFormNotEmpty || haveFocus);
  }, [visibleProp, subFormNotEmpty, haveFocus]);

  return (
    <fieldset
      className={cx(
        { hidden: !visible },
        subFormNotEmpty ? status : 'idle',
      )}
      onAnimationStart={(e) => {
        // Because of the timeout and given the event bubbles, the `currentTarget` will change, so we must capture it first
        const target = e.currentTarget;
        // Change the timing function to linear at the point where the bezier curve is essentially linear
        setTimeout(() => {
          target.style.setProperty('animation-timing-function', 'linear');
        }, FONT_SETTINGS_BORDER_ANIMATION_DURATION * 0.75);
      }}
      onAnimationEnd={(e) => {
        e.currentTarget.style.removeProperty('animation-timing-function');
      }}
      onFocus={() => setHaveFocus(true)}
      onBlur={() => setHaveFocus(false)}
    >
      <Subform setSubFormNotEmpty={setSubFormNotEmpty} state={subformState} />
    </fieldset>
  );
}
